import { Link } from "react-router-dom";
import { MapPin, Clock, User as UserIcon } from "lucide-react";
import { LEVEL_META, timeAgoFr, truncate, formatDateTimeFr } from "@/lib/format";

export default function AlertCard({ alert, showClosed = false, pulse = false }) {
  const meta = LEVEL_META[alert.level] || LEVEL_META.green;
  const mainTime = showClosed ? alert.closed_at : alert.created_at;
  const isRedActive = pulse && alert.level === "red" && alert.status === "active";

  return (
    <Link
      to={`/alert/${alert.id}`}
      data-testid={`alert-card-${alert.short_id}`}
      className={`group relative block overflow-hidden rounded-[16px] border bg-white p-4 transition hover:border-slate-300 hover:shadow-[0_4px_20px_-8px_rgba(15,23,42,0.12)] ${
        isRedActive ? "sa-red-pulse" : "border-slate-200"
      }`}
      style={
        isRedActive
          ? { background: "linear-gradient(135deg, #FFF1F2 0%, #ffffff 70%)" }
          : undefined
      }
    >
      {/* Left colored bar */}
      <span
        aria-hidden
        className={`absolute left-0 top-0 h-full ${isRedActive ? "sa-red-bar" : ""}`}
        style={{ backgroundColor: meta.color, width: 4 }}
      />
      <div className="pl-3">
        <div className="flex items-start justify-between gap-3">
          <div className="flex min-w-0 flex-1 flex-col">
            <div className="flex items-center gap-2">
              <span
                className="inline-flex h-5 items-center rounded-full px-2 text-[10px] font-semibold uppercase tracking-wider"
                style={{ backgroundColor: meta.bg, color: meta.ink }}
              >
                {meta.label}
              </span>
              {alert.status === "closed" ? (
                <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">
                  Clôturée
                </span>
              ) : null}
            </div>
            <h3
              className="mt-2 flex items-center gap-1.5 text-[15px] font-semibold text-slate-900"
              style={{ letterSpacing: "-0.01em" }}
            >
              <UserIcon size={14} className="text-slate-400" />
              {alert.agent_snapshot?.full_name || "—"}
            </h3>
          </div>
          <div
            className="flex shrink-0 items-center gap-1 text-[11px] font-medium text-slate-500"
            title={formatDateTimeFr(mainTime)}
          >
            <Clock size={11} />
            <span>{timeAgoFr(mainTime)}</span>
          </div>
        </div>

        <div className="mt-3 flex items-start gap-2 text-[13px] text-slate-600">
          <MapPin size={14} className="mt-0.5 shrink-0 text-slate-400" />
          <span className="leading-snug" style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
            {alert.address || "Adresse non renseignée"}
          </span>
        </div>

        {alert.client_name ? (
          <div className="mt-2 text-[12px] font-medium text-slate-500">
            Client · <span className="text-slate-700">{truncate(alert.client_name, 40)}</span>
          </div>
        ) : null}

        <div className="mt-3 flex items-center justify-end">
          <span className="text-[12px] font-semibold text-[var(--sa-blue)] group-hover:underline">
            Voir le détail →
          </span>
        </div>
      </div>
    </Link>
  );
}
